import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Vet omzetten in spier: is het mogelijk?</title>
                <link rel="canonical" href={route("blogs.sixth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="We horen vaak voorbij komen dat mensen vet willen omzetten in spiermassa. De vraag is echter of dit überhaupt wel mogelijk is? Dit antwoord is heel kort en eenvoudig: Nee."
                />
                <meta
                    property="og:description"
                    content="We horen vaak voorbij komen dat mensen vet willen omzetten in spiermassa. De vraag is echter of dit überhaupt wel mogelijk is? Dit antwoord is heel kort en eenvoudig: Nee."
                />
                <meta property="og:url" content={route("blogs.sixth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Vet omzetten in spier: is het mogelijk? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/vet-omzetten.jpeg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/vet-omzetten.webp"
                                    type="image/webp"
                                    alt="Vet omzetten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/vet-omzetten.jpeg"
                                    type="image/jpeg"
                                    alt="Vet omzetten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/vet-omzetten.jpeg"
                                    alt="Vet omzetten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Vet omzetten in spier: is het mogelijk?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        We horen vaak voorbij komen dat mensen vet willen
                        omzetten in spiermassa. De vraag is echter of dit
                        überhaupt wel mogelijk is? Dit antwoord is heel kort en
                        eenvoudig: Nee. Het is niet mogelijk om je vet om te
                        zetten in spieren omdat dit twee verschillende processen
                        zijn. Letterlijk je vetmassa omzetten in spiermassa kan
                        dus niet, maar kunnen deze twee processen wel
                        tegelijkertijd gebeuren?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Vetmassa verliezen
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Om je vetmassa te verminderen is het nodig dat je een
                        calorietekort hanteert. Dit wil zeggen dat je meer
                        verbrandt dan dat je binnen krijgt. Dit kun je doen door
                        minder te gaan eten, meer te gaan bewegen of een
                        combinatie van beide. Hierbij werkt een goede combinatie
                        van training en voeding het beste om zoveel mogelijk
                        vetmassa te verliezen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Spiermassa creëren
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Voor het opbouwen van spiermassa is een goede combinatie
                        van training en voeding van belang. Het is belangrijk om
                        meer spieren op te bouwen dan je lichaam afbreekt. Dit
                        zorgt ervoor dat je sterker word en je spieren in massa
                        toenemen. Om dit te realiseren moet je voldoende
                        eiwitten en calorieën binnen krijgen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je niet genoeg calorieën binnenkrijgt heeft dat een
                        negatieve invloed op de spiereiwitsynthese. Dit zorgt
                        weer voor spierafbraak, waardoor je spieren dus niet
                        zullen groeien.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Tegelijkertijd vetmassa verliezen en spiermassa creëren
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Uit onderzoek blijk dat het in specifieke gevallen
                        mogelijk is om tegelijkertijd vetmassa te verliezen en
                        spiermassa te creëren. Het is namelijk zo dat mensen met
                        fors overgewicht die gebruik maken van krachttraining
                        tegelijkertijd vetmassa kunnen verliezen en spiermassa
                        opbouwen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Dit komt omdat deze groep veelal insulineresistent is.
                        Hierdoor zal bij intensieve inspanning sneller vetmassa
                        gebruikt dan je koolhydratenvoorraad. Dit is echter
                        tijdelijk, omdat krachttraining juist een negatieve
                        werking heeft op de insulineresistentie. Na een tijdje
                        is het dus voor deze groep ook niet meer mogelijk om
                        vetmassa te verliezen en spiermassa te winnen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Daarnaast zijn er nog verschillende onderzoeken dit
                        aantoonden dat beginnende sporters in krachttraining ook
                        mogelijk spiermassa kunnen opbouwen terwijl ze vetmassa
                        verliezen. Dit zijn de zogenoemde ‘newbie gains’. Als
                        laatste kunnen sporters die langdurig geen gebruik
                        hebben gemaakt van krachttraining die dit in het
                        verleden wel hebben gedaan op het begin ook
                        tegelijkertijd vetmassa verliezen en spiermassa
                        opbouwen. Dit is echter van korte duur en zal weer snel
                        verdwijnen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Dit komt omdat je sneller spiermassa opbouwt als je
                        (weer) begint met krachttraining. Je spieren worden hard
                        aan het werk gezet en moeten zich snel aanpassen op de
                        prikkel die je krijgt bij nieuwe of hernieuwde
                        krachttraining.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Zo lees je dus dat het daadwerkelijk wel mogelijk is om
                        spiermassa op te bouwen en vetmassa te verliezen, echter
                        zit hier een enorme maar aan. Dit is namelijk alleen in
                        specifieke gevallen het geval en is in al deze gevallen
                        slechts kort en tijdelijk.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Daarbij moet je ook de juiste voeding en training
                        combineren om het mogelijk te maken. Zo moet je
                        voldoende krachttraining gebruiken in de week. Dit komt
                        neer op minimaal twee keer in de week. Qua voeding mag
                        je geen te groot tekort hanteren en moet je voldoende
                        eiwitten binnen krijgen. Zo niet zul je geen spiermassa
                        meer kunnen opbouwen.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
